/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Supplier API
 * Areeb Supplier REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCatalogForSupplier200ResponseCatalog
 */
export interface GetCatalogForSupplier200ResponseCatalog {
    /**
     * 
     * @type {number}
     * @memberof GetCatalogForSupplier200ResponseCatalog
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof GetCatalogForSupplier200ResponseCatalog
     */
    organizationId?: number;
    /**
     * 
     * @type {Date}
     * @memberof GetCatalogForSupplier200ResponseCatalog
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetCatalogForSupplier200ResponseCatalog
     */
    updatedAt?: Date;
}

/**
 * Check if a given object implements the GetCatalogForSupplier200ResponseCatalog interface.
 */
export function instanceOfGetCatalogForSupplier200ResponseCatalog(value: object): value is GetCatalogForSupplier200ResponseCatalog {
    return true;
}

export function GetCatalogForSupplier200ResponseCatalogFromJSON(json: any): GetCatalogForSupplier200ResponseCatalog {
    return GetCatalogForSupplier200ResponseCatalogFromJSONTyped(json, false);
}

export function GetCatalogForSupplier200ResponseCatalogFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCatalogForSupplier200ResponseCatalog {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function GetCatalogForSupplier200ResponseCatalogToJSON(value?: GetCatalogForSupplier200ResponseCatalog | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'organizationId': value['organizationId'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
    };
}

